<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Store"
              bc1="App"
              bc2="Store"
              bc3="List"
          ></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
                type="button"
                class="btn btn-gradient-danger btn-sm"
                @click="backTo"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
      </div>
      <div class="content-body">
        <div class="card">
          <h5 class="card-header">Search Filter</h5>
          <div class="row m-25">
            <div class="col-lg-8 mb-1 col-sm-12">
              <SearchSelect
                  v-model="selectedMerchant"
                  url="v1/get-merchants"
                  :filterParams="{ flag: 'all' }"
                  :customLabelFn="customNameForMultiselect"
                  ref="merchantSearchSelect"
                  placeholder="Search Merchant..."
              />
            </div>
            <div class="col-lg-4 mb-1 col-sm-12">
              <input class="form-control" @keyup.enter="onSubmitFilters" type="text" v-model="search" placeholder="Search here..."/>
            </div>
          </div>
          <div class="row m-25">
            <div class="col-lg-6 mb-1 col-sm-12">
              <button type="button" class="btn btn-primary"  @click="onSubmitFilters" >Search</button>
              <button type="button" class="ml-1 btn btn-danger " @click="clear" >Clear</button>
            </div>
          </div>

        </div>
        <div class="card">
          <div class="m-2">
            <div class="row">
            </div>
          </div>

          <CommonTable
              :url="url"
              :tableHeaderValues="tableHeaderValues"
              :actions="actions"
              :deleteActions="deleteActions"
              :mutedData="mutedData"
              :storageKey="storageKey"
              :filteredData="filteredData"
              :externalTotalRecord="externalTotalRecord"
              :show-per-page="true"
              :actionDropdown="true"
          />
        </div>
      </div>
    </div>
    <StoreUpdateStatusModal :show="showStatusUpdateModal" @hide="showStatusUpdateModal = false" @completed="completedAction" :row="selectedRowForStatus" />
    <StoreLogsModal :show="showLogsModal" :data="selectedDetails" @hide="showLogsModal = false" />
    <TabbyConfigurationModal
      :show="showTabbyConfigModal"
      :row="selectedRowForTabbyConfig"
      type="store"
      configurationType="storeConfigurations"
      modalSize="lg"
      modalTitle="Store Service Configuration"
      @hide="showTabbyConfigModal = false"
      @completed="completedTabbyConfig"
    />
    <!-- Send Report Modal -->
    <b-modal v-model="showReportModal" title="Send Vat Report to Merchant" hide-footer>
      <form @submit.prevent="sendReport">
        <div class="form-group">
          <label>Month</label>
          <date-picker
              v-model="reportForm.month"
              type="month"
              format="MMM YYYY"
              valueType="format"
              valueFormat="YYYY-MM"
              :disabledDate="disableFutureMonths"
              :lang="lang"
              name="month"
              placeholder="Choose month"
              class="w-100"
          />
          <input type="hidden" name="month" v-validate="'required'" v-model="reportForm.month">
          <small
              v-show="errorBag.has('month')"
              class="text-danger"
          >{{ "*" + errorBag.first("month") }}</small>
        </div>
        <div class="d-flex justify-content-end mt-2">
          <b-button type="button" variant="outline-secondary" class="mr-1" @click="showReportModal = false">
            Cancel
          </b-button>
          <b-button type="submit" variant="primary">
            Send Report
          </b-button>
        </div>
      </form>
    </b-modal>
  </div>
  <!-- END: Content-->
</template>

<script>


import StoreUpdateStatusModal from "@/pages/dashboard/merchant/stores/StoreUpdateStatusModal.vue";
import StoreLogsModal from "@/pages/dashboard/merchant/stores/StoreLogsModal.vue";
import SearchSelect from "@/components/common/SearchSelect.vue";
import DatePicker from "vue2-datepicker";
import TabbyConfigurationModal from "@/pages/dashboard/merchant/channels/TabbyConfigurationModal.vue";

export default {
  components: {SearchSelect, StoreLogsModal, StoreUpdateStatusModal, DatePicker, TabbyConfigurationModal},
  props: ['propFilters'],
  created() {},
  mounted() {
    localStorage.setItem("url", "v1/get-store");
    this.checkDataInStore('v1/get-store')
    if (
        typeof this.$route.params.update == "undefined" &&
        typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }
    // var merchantStore = this.$store.getters.getByKey(
    //     "merchantStore"
    // );
    // this.userId = merchantStore.row.id
    // this.filteredData = {
    //   userId: this.userId
    // }

    // this.currentBreadCrumb.push(merchantStore.row.first_name)
  },
  data() {
    return {
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
      showReportModal: false,
      reportForm: {
        month:null,
        storeId: null
      },
      selectedMerchant: null,
      showLogsModal:false,
      selectedDetails: [],
      currentBreadCrumb:[],
      url: "v1/get-store",
      storageKey: "merchantStoreList2",
      force:false,
      search: "",
      tableHeaderValues: [
        {
          title: "Name",
          valueKey: "name",
          html: true,
          alter: (value, row) => {
            var html = value;
            if (row?.created_by_user) {
              html = `
                <div class="row">
                    <div class="col-12 text-center">
                        <div class=""><span class="text-primary">${value}</span></div>
                        <div class="badge badge-dark mt-1">${row.created_by_user.first_name + " " + row.created_by_user.last_name}</div>
                    </div>
                </div>
                `
            }

            return html
          }
        },
        {
          title: "User",
          valueKey: "name",
          html: true,
          alter: (value, row) => {
            var html = "";
            if (row.user) {
              html = `<span class="">${row.user.first_name + " " + row.user.last_name + " (" + row.user.email + ")"}</span>`;
              return html;
            } else {
              html = "-";
              return html;
            }
          }
        },
        {
          title: "MCC Code",
          valueKey: "mcc_code",
          html: true,
          alter: function(value) {
            var html = "";
            if (value) {
              html = `<span class="text-primary">${value}</span>`;
              return html;
            } else {
              html = "-";
              return html;
            }
          }
        },
        {
          title: "TRN",
          valueKey: "tax_registration_number",
        },
        {
          title: "Merchant Descriptor",
          valueKey: "merchant_descriptor",
          html: true,
          alter: function(value) {
            return value ? `<span>${value}</span>` : "-";
          }
        },
        {
          title: "Code",
          valueKey: "code",
          html: true,
          alter: function(value) {
            var html = "";
            if (value) {
              html = `<span class="text-primary">${value}</span>`;
              return html;
            } else {
              html = "-";
              return html;
            }
          }
        },
        {
          title: "Auto Settlement",
          valueKey: "auto_settlement",
          html: true,
          alter: function(value) {
            // 0 = Stop, 1 = Store, 2 = Channel
            const labels = {
              0: ['Stop', 'badge-light-danger'],
              1: ['Store', 'badge-light-info'],
              2: ['Channel', 'badge-light-primary'],
            };
            const entry = labels[value];
            return entry ? `<span class="badge ${entry[1]}">${entry[0]}</span>` : "-";
          }
        },
        {
          title: 'Status',
          valueKey: 'status',
          html: true,
          alter:  (value,row) => {
            var html = ''
            if (value == 0)
              html = `<div class="badge badge-pill  badge-glow badge-light-warning">Deactive</div>`
            else if(value == 1)
              html = `<div class="badge badge-pill  badge-glow badge-light-success">Active</div>`
            else if(value == 2)
              html = `<div class="badge badge-pill  badge-glow badge-light-danger">Request For Changes</div>`
            else if(value == 3)
              html = `<div class="badge badge-pill  badge-glow badge-light-info">Pending Approval</div>`
            else if(value == 4)
              html = `<div class="badge badge-pill  badge-glow badge-light-secondary">Draft</div>`

            if(row.type == 0){
              html = `
                <div class="row">
                    <div class="col-12 ">
                       ${html}
                        <div class="badge badge-light-primary mt-1">Default</div>
                    </div>
                </div>
                `
            }

            return html

          }
        },
        {
          title: 'Created At',
          valueKey: 'created_at',
          html:true,
          alter: (value) => {
            return `<span class="badge text-dark">${this.customFormatDateTime(value)}</span>`
          }
        },
        {
          title: 'Updated At',
          valueKey: 'updated_at',
          html:true,
          alter: (value) => {
            return `<span class="badge text-dark">${this.customFormatDateTime(value)}</span>`
          }
        },
      ],
      actions: [
        {
          title: "Update",
          class: 'badge btn-primary',
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "merchantStoreUpdate2"
            };
            this.$store.dispatch("set", data);
            this.$router.push({ name: "merchant-update-store",params: {userId : row.user?.id} });
          }
        },
        {
          title: 'View Comments',
          class: 'badge btn-primary',
          cta: (row) => {
            this.selectedDetails = row.details ?? []
            this.showLogsModal = true
          }
        },
        {
          title: 'Terminal',
          class: 'badge btn-primary',
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "merchantTerminal"
            };
            this.$store.dispatch("set", data);
            this.$router.push({ name: "terminal" });
          },

        },
        {
          title: "Update Status",
          class: 'badge btn-primary',
          cta: (row, index) => {
            this.selectedRowForStatus = row
            this.showStatusUpdateModal = true
          }
        },
        {
          title: 'Send Report To Merchant',
          class: 'btn-info badge',
          cta: (row) => {
            this.reportForm.storeId = row.id;
            this.reportForm.month = '';
            this.showReportModal = true;
          }
        },
        {
          title: 'Onboard Via Switch',
          class: 'badge btn-primary',
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "storeOnboardPFAC"
            };
            this.$store.dispatch("set", data);


            this.$router.push({ name: "switch"});
          },

        },
        {
          title: "View Submission",
          class: 'btn-primary badge ml-50',
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "merchantStoreActivation"
            };
            this.$store.dispatch("set", data);
            this.$router.push({ name: "account-activation"});
          }
        },
        {
          title: "Configuration",
          class: 'badge btn-primary',
          cta: (row) => {
            this.selectedRowForTabbyConfig = row;
            this.showTabbyConfigModal = true;
          }
        },
        {
          title: "Settlement Configuration",
          class: 'badge btn-primary',
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "storeSettlementConfiguration"
            };
            this.$store.dispatch("set", data);
            this.$router.push({ name: "merchant-store-settlement-configuration", params: {storeId : row.id} });
          }
        },
      ],
      deleteActions: [
        // {
        //   title: "Delete",
        //   class: " ml-1 custom-control-primary",
        //   cta: (row, index) => {
        //     let data = {
        //       index: index,
        //       row: row,
        //       key: "merchantStoreDelete"
        //     };
        //     this.deleteRecord(data);
        //   }
        // }
      ],
      mutedData: [],
      externalTotalRecord: "",
      filteredData:{serviceConfiguration:1, settlementConfiguration:1},
      userId:'',
      showStatusUpdateModal: false,
      selectedRowForStatus: null,
      showTabbyConfigModal: false,
      selectedRowForTabbyConfig: null,
    };
  },
  methods: {
    async sendReport() {
      this.$validator.validateAll().then(valid => {
        if(valid){
          this.$store.dispatch('exportExcelLoader', true)
          let data = {
            type: 'vat',
            typeId: this.reportForm.storeId,
            period: this.getRequestMonth(this.reportForm.month),
          }

          this.makeRequest("post", "v1/merchant-report", data).then(
              (callResponse) => {
                this.$store.dispatch('exportExcelLoader', false)
                this.showReportModal = false;
              }
          );
        }})

    },
    customNameForMultiselect({ email, first_name, business_name }) {
      const nameToUse = business_name === null || business_name === '' ? first_name : business_name;
      return `${email}/${nameToUse}`;
    },
    onSubmitFilters() {

      let filterData = {serviceConfiguration:1, settlementConfiguration:1}


      if(this.search != ''){
        filterData.search = this.search
      }

      if(this.selectedMerchant){
        filterData.userId = this.selectedMerchant.id
      }

      this.filteredData = filterData

    },
    clear(){
      this.search = ''
      this.selectedMerchant = null
      this.$refs.merchantSearchSelect.reset();
      this.filteredData = {serviceConfiguration:1, settlementConfiguration:1}
    },
    backTo() {
      let propFilters = this.propFilters
      this.$router.push({ name: 'merchants', params: { propFilters } })
    },
    completedAction() {
      this.$store.dispatch('renderPagination', !this.force);
      this.force = !this.force;
      this.showStatusUpdateModal = false
    },
    routeToAddRecord(){
      this.$router.push({ name: "add-store",params: {userId : this.userId}})

    },
    completedTabbyConfig() {
      this.$store.dispatch('renderPagination', !this.force);
      this.force = !this.force;
    },
    deleteRecord(data) {
      this.makeRequest("post", "v1/delete-store", {
        status: data.row.status == true ? 1 : 0,
        storeId: data.row.id
      }).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          if (code == 200) {
            let storeData = this.$store.getters.getByKey(this.storageKey);
            if (storeData != null) {
              if (typeof storeData.firstPageData != "undefined") {
                if (
                    typeof storeData.firstPageData.data[data.index] != "undefined"
                ) {
                  if (
                      storeData.firstPageData.data[data.index].id == data.row.id
                  ) {
                    storeData.firstPageData.data[data.index] = data.row;
                    delete storeData.otherPageData;
                  }
                }
              }
              if (typeof storeData.otherPageData != "undefined") {
                if (
                    typeof storeData.otherPageData.data[data.index] != "undefined"
                ) {
                  if (
                      storeData.otherPageData.data[data.index].id == data.row.id
                  ) {
                    storeData.otherPageData.data[data.index] = data.row;
                  }
                }
              }
              storeData.key = this.storageKey;
              this.$store.dispatch("set", storeData);
            }
          }
        }
      });
    }
  }
};
</script>
